import React from 'react';
import { Outlet } from 'react-router-dom';
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import SubNav from '../../Components/Profile/SubNav';
import './profile.css';

const Profile = () => {

  const subNavItems = [
    { id: 1, label: 'About', path: 'about' },
    { id: 2, label: 'Web Developer', path: 'web-developer' },
    { id: 3, label: 'Instrumentation', path: 'instrumentation' },
    { id: 4, label: 'Health Coach', path: 'health-coach' }
  ];

	return (
		<div className='box-shadow'>
			<SectionHeader name={'Profile'} />
			<SubNav navItems = {subNavItems} />	
			<div 
				className='padding' 
				style={{ 
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',				
				}}
			>
				<Outlet /> 
			</div>
			
		</div>
	)
}

export default Profile;